import React from "react";

const SharePointContentPage = ({ data, onClose }) => {
  if (!data) return null;

  // Helper to guess icon based on text
  const getIcon = (text) => {
    if (text.includes("Pitch") || text.includes("Deck")) return "PPT";
    if (text.includes("Video") || text.includes("Recording")) return "VID";
    return "DOC";
  };

  const getIconColor = (type) => {
    switch (type) {
      case "PPT": return "#d04423"; // PowerPoint Orange
      case "VID": return "#0078d4"; // Stream Blue
      case "DOC": return "#2b579a"; // Word Blue
      default: return "#107c10"; // Excel/Other Green
    }
  };

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: '#f3f2f1', zIndex: 3000, display: 'flex', flexDirection: 'column',
      fontFamily: '"Segoe UI", "Helvetica Neue", sans-serif',
    }}>
      
      {/* 1. SUITE NAV BAR */}
      <div style={{ height: "48px", background: "#0078d4", display: "flex", alignItems: "center", padding: "0 1rem", justifyContent: "space-between", color: "white" }}>
        <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "2px", width: "16px" }}>
             {[...Array(9)].map((_, i) => <div key={i} style={{ width: "4px", height: "4px", background: "white" }}></div>)}
          </div>
          <span style={{ fontWeight: "600", fontSize: "1rem" }}>SharePoint</span>
        </div>
        <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
           <span>?</span>
           <div style={{ width: "32px", height: "32px", borderRadius: "50%", background: "rgba(255,255,255,0.2)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "0.8rem" }}>JD</div>
        </div>
      </div>

      {/* 2. SITE HEADER */}
      <div style={{ height: "120px", background: "white", borderBottom: "1px solid #e1dfdd", display: "flex", alignItems: "flex-end", padding: "0 2rem 1rem" }}>
        <div style={{ display: "flex", alignItems: "flex-end", gap: "1rem", width: "100%" }}>
          <div style={{ width: "64px", height: "64px", background: "#7C3AED", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "1.5rem", color: "white", borderRadius: "4px" }}>
            AC
          </div>
          <div style={{ marginBottom: "0.5rem", flex: 1 }}>
            {/* ✅ FIXED LINE: Escaped the '>' character */}
            <div style={{ fontSize: "0.9rem", color: "#605e5c", marginBottom: "0.25rem" }}>
              ACME Sales Academy {' > '} {data.role} Path
            </div>
            <h1 style={{ fontSize: "1.75rem", fontWeight: "600", margin: 0, color: "#201f1e" }}>{data.phaseName}</h1>
          </div>
          <button onClick={onClose} style={{ padding: "0.5rem 1rem", background: "#f3f2f1", border: "none", borderRadius: "4px", cursor: "pointer", fontWeight: "600" }}>
            Exit Preview
          </button>
        </div>
      </div>

      {/* 3. MAIN CONTENT AREA */}
      <div style={{ flex: 1, display: "flex", overflow: "hidden" }}>
        
        {/* Left Nav */}
        <div style={{ width: "220px", padding: "2rem 1rem", background: "#f3f2f1" }}>
          <ul style={{ listStyle: "none", padding: 0, fontSize: "0.9rem", color: "#605e5c" }}>
            <li style={{ padding: "0.5rem", fontWeight: "600", color: "#201f1e", borderLeft: "4px solid #0078d4", background: "#e1dfdd" }}>Documents</li>
            <li style={{ padding: "0.5rem" }}>Home</li>
            <li style={{ padding: "0.5rem" }}>Conversations</li>
            <li style={{ padding: "0.5rem" }}>Site Contents</li>
            <li style={{ padding: "0.5rem" }}>Recycle Bin</li>
          </ul>
        </div>

        {/* Document Library */}
        <div style={{ flex: 1, padding: "2rem", background: "white", margin: "1rem", borderRadius: "4px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)", overflowY: "auto" }}>
          
          {/* Toolbar */}
          <div style={{ display: "flex", gap: "1.5rem", borderBottom: "1px solid #e1dfdd", paddingBottom: "1rem", marginBottom: "1rem", fontSize: "0.9rem", color: "#0078d4", fontWeight: "600" }}>
            <span>+ New</span>
            <span style={{ color: "#201f1e" }}>Upload</span>
            <span style={{ color: "#201f1e" }}>Share</span>
            <span style={{ color: "#201f1e" }}>Export to Excel</span>
          </div>

          {/* List Header */}
          <div style={{ display: "grid", gridTemplateColumns: "40px 3fr 1fr 1fr", padding: "0.5rem 0", borderBottom: "1px solid #e1dfdd", fontSize: "0.8rem", color: "#605e5c", fontWeight: "600" }}>
            <div>Type</div>
            <div>Name</div>
            <div>Modified</div>
            <div>Modified By</div>
          </div>

          {/* List Items */}
          {data.items.map((item, i) => {
            const iconType = getIcon(item);
            return (
              <div key={i} style={{ display: "grid", gridTemplateColumns: "40px 3fr 1fr 1fr", padding: "1rem 0", borderBottom: "1px solid #f3f2f1", alignItems: "center", fontSize: "0.9rem" }}>
                <div style={{ color: getIconColor(iconType), fontWeight: "bold", fontSize: "0.8rem" }}>{iconType}</div>
                <div style={{ color: "#201f1e", cursor: "pointer", fontWeight: "500" }}>{item}</div>
                <div style={{ color: "#605e5c", fontSize: "0.8rem" }}>Just now</div>
                <div style={{ color: "#605e5c", fontSize: "0.8rem" }}>System Admin</div>
              </div>
            );
          })}

          {/* Empty State Fillers for realism */}
          <div style={{ display: "grid", gridTemplateColumns: "40px 3fr 1fr 1fr", padding: "1rem 0", borderBottom: "1px solid #f3f2f1", alignItems: "center", fontSize: "0.9rem", opacity: 0.5 }}>
            <div style={{ color: "#107c10", fontWeight: "bold", fontSize: "0.8rem" }}>XLS</div>
            <div>Evaluation_Rubric_v2.xlsx</div>
            <div>Yesterday</div>
            <div>Jane Doe</div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default SharePointContentPage;
